import { render, staticRenderFns } from "./aboutQqbj.vue?vue&type=template&id=49551fe2&scoped=true"
import script from "./aboutQqbj.vue?vue&type=script&lang=js"
export * from "./aboutQqbj.vue?vue&type=script&lang=js"
import style1 from "./aboutQqbj.vue?vue&type=style&index=1&id=49551fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49551fe2",
  null
  
)

export default component.exports